const CALL_AGENT_STATUS = [
  { value: 1, label: '在线' },
  { value: 2, label: '离线' },
  { value: 3, label: '小休' },
  { value: 4, label: '忙碌' },
  { value: 6, label: '通话中' },
  { value: 7, label: '振铃中' },
  { value: 8, label: '整理中' },
  { value: 11, label: '监听中' }
];

const RECORD_STATUS = [
  { value: 'ivr', label: 'ivr挂断' },
  { value: '队列放弃', label: '队列放弃' },
  { value: '振铃未接', label: '客服未接听' },
  { value: '接听', label: '正常接听' },
  { value: '被叫未接', label: '顾客未接听' },
  { value: '主叫未接', label: '客服未接听' },
  { value: '顾客未接听', label: '顾客未接听' },
  { value: '客服未接听', label: '客服未接听' },
  { value: '队列超时', label: '队列超时' },
  { value: '客户速挂', label: '客户速挂' }
];

const RECORD_TEPYS = [
  { value: '来电', label: '呼入' },
  { value: '外呼', label: '呼出' },
  { value: '呼入转接', label: '呼入（转接）' },
  { value: '呼出转接', label: '呼出（转接）' },
  { value: '呼入语音机器人', label: '呼入（语音机器人）' }
];

const CALL_SUMMARY_ITEMS_TYPES = [
  { value: 'single_line', label: '单行文本' },
  { value: 'multi_line', label: '多行文本' },
  { value: 'pull_down_radio', label: '下拉单选' },
  { value: 'pull_down_check', label: '下拉多选' },
  { value: 'radio', label: '单选' },
  { value: 'check', label: '复选' },
  { value: 'number', label: '数字' },
  { value: 'date', label: '时间' },
  { value: 'rich_text', label: '富文本' }
];

const ANSWER_WAYS = [
  {
    value: 'web:rtc',
    label: '网页接听',
    icon: 'ecoboost-iconfontdesktop1'
  },
  {
    value: 'mobile',
    label: '手机接听',
    icon: 'ecoboost-iconfontmobile'
  },
  {
    value: 'soft_switch',
    label: '软电话接听',
    icon: 'ecoboost-iconfontmobile_02'
  }
];

const SIP_TYPES = [
  { value: 1, label: '仅呼入' },
  { value: 2, label: '仅呼出' },
  { value: 3, label: '呼入/呼出' }
];

const NUMBER_TYPES = [
  { value: 1, label: '手机号码' },
  { value: 2, label: '固定号码' },
  { value: 3, label: '随机号码' },
  { value: 4, label: '自有号码' }
];

const NUMBER_USAGE = [
  { value: 1, label: '仅呼入' },
  { value: 2, label: '仅呼出' },
  { value: 3, label: '呼入/呼出' }
];

const AGENT_EVALUATED = [
  { value: 0, label: '未评价' },
  { value: 1, label: '非常满意' },
  { value: 2, label: '满意' },
  { value: 3, label: '不满意' }
];

const CALL_OUT_TASK_STATUS = [
  { value: 'not_started', label: '未开始' },
  { value: 'processing', label: '执行中' },
  { value: 'expires', label: '已结束' }
];

export default {
  RECORD_STATUS,
  RECORD_TEPYS,
  CALL_SUMMARY_ITEMS_TYPES,
  CALL_AGENT_STATUS,
  NUMBER_TYPES,
  NUMBER_USAGE,
  AGENT_EVALUATED,
  ANSWER_WAYS,
  SIP_TYPES,
  CALL_OUT_TASK_STATUS
};
